const BASE_CONFIG = {
  mode: 'cors',
  credentials: 'same-origin',
};

/**
 * 'request' function to use fetch that throws an error if the response is not ok.
 *
 * @param url {RequestInfo | URL}
 * @param config {RequestInit}
 * @returns {TResponse}
 */
async function request<TResponse>(url: RequestInfo | URL, config?: RequestInit): Promise<TResponse> {
  const response = await fetch(url, { ...BASE_CONFIG, ...config } as RequestInit);
  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }
  const resultText = await response.text();

  return (resultText ? JSON.parse(resultText) : { status: 'ok' }) as TResponse;
}

export default request;
